<template>
    <!-- @deprecated, use <Icons /> instead -->
    <svg class="svgIcon">
        <use v-bind:xlink:href="`#${iconName}`" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: 'SvgIcon',
        props: {
            iconName: {
                type: String,
                default: '',
            },
        },
    });
</script>
